import { SystemTags } from '../../db/constants';
import { Page } from '../../db/pages';

export interface TagAttachment {
  name: string;
  humanEdit: boolean;
  inferenceStrength: number;
  proportion: number; // for multiselect, [0, 1]
}

export interface AggregateTagAttachment {
  name: string;
  humanEditProportion: number;
  inferenceStrength: number;
  proportion: number; // for multiselect, [0, 1]
}

export function aggregateTags(
  pages: Page[]
): { [key: string]: AggregateTagAttachment } {
  const tags = pages.flatMap((page) => {
    const humanTags: TagAttachment[] = page.humanTags.map((tag) => {
      return {
        name: tag,
        humanEdit: false,
        inferenceStrength: 1,
        proportion: 1,
      };
    });

    const autoTags: TagAttachment[] = page.autoTags?.map((autotag) => {
      return {
        name: autotag.name,
        humanEdit: true,
        inferenceStrength: autotag.inferenceStrength,
        proportion: 1,
      };
    });

    return humanTags
      .concat(autoTags)
      .filter(Boolean)
      .filter((tag) => !SystemTags.includes(tag.name));
  });

  // group by tag
  const tagAttachmentsByTag = Object.groupBy(tags, (tag) => tag.name);

  // aggregate strengths and proportions
  const emptyAggregate: AggregateTagAttachment = {
    name: '',
    humanEditProportion: 0,
    inferenceStrength: 0,
    proportion: 0,
  };

  function aggregateTag(acc: AggregateTagAttachment, tag: TagAttachment): AggregateTagAttachment {
    if (!(acc.name === tag.name || acc.name === '')) {
      throw new Error('reducer: acc.name !== tag.name');
    }
    return {
      name: tag.name,
      humanEditProportion: acc.humanEditProportion + (tag.humanEdit ? 1 : 0),
      inferenceStrength: acc.inferenceStrength + tag.inferenceStrength,
      proportion: acc.proportion + tag.proportion,
    };
  }

  const tagAggregates = Object.fromEntries(
    Object.entries(tagAttachmentsByTag).map(([tag, tags]) => {
      const p = tags?.reduce(aggregateTag, emptyAggregate) ?? emptyAggregate;
      return [tag, p];
    })
  );

  // normalize proportions and strengths
  const tagAggregatesNormalized: { [key: string]: AggregateTagAttachment } = Object.fromEntries(
    Object.entries(tagAggregates)
      .map(([tag, agg]) => {
        return [
          tag,
          {
            name: tag,
            humanEditProportion: agg.humanEditProportion / pages.length,
            inferenceStrength: agg.inferenceStrength / pages.length,
            proportion: agg.proportion / pages.length,
          },
        ];
      })
      .map(([tag, agg]) => {
        const aggX = agg as AggregateTagAttachment;
        return [
          tag,
          {
            name: tag,
            // humanEditProportion: Math.min(1.0, aggX.humanEditProportion * scaleFactor),
            // inferenceStrength: Math.min(1.0, aggX.inferenceStrength * scaleFactor),
            // proportion: Math.min(1.0, aggX.proportion * scaleFactor),
            humanEditProportion: aggX.humanEditProportion,
            inferenceStrength: aggX.inferenceStrength,
            proportion: aggX.proportion,
          },
        ];
      })
  );
  return tagAggregatesNormalized;
}
